import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
function EmptyState({
  icon,
  title,
  text,
  actions,
  ...props
}) {
  return /* @__PURE__ */ jsxs(EmptyStateStyled, {
    ...props,
    children: [icon && /* @__PURE__ */ jsx(Image, {
      children: icon
    }), /* @__PURE__ */ jsx(Title, {
      children: title
    }), /* @__PURE__ */ jsx(Description, {
      children: text
    }), actions ? /* @__PURE__ */ jsx(Actions, {
      children: actions
    }) : null]
  });
}
const EmptyStateStyled = styled.div.withConfig({
  displayName: "EmptyStateStyled",
  componentId: "sc-13lgb7y-0"
})(["display:grid;grid-template-columns:minmax(10px,472px);justify-content:center;justify-items:center;text-align:center;"]);
const Image = styled.p.withConfig({
  displayName: "Image",
  componentId: "sc-13lgb7y-1"
})(["display:grid;place-items:center;width:128px;height:128px;margin:0 0 ", ";border-radius:", ";background:", ";color:", ";svg{width:48px;height:48px;}"], token.spacing5, token.radiusCircle, token.gray25, token.colorTextDisabled);
const Title = styled.h2.withConfig({
  displayName: "Title",
  componentId: "sc-13lgb7y-2"
})(["", " margin:0 0 ", ";color:", ";"], textStyles.headingM, token.spacing4, token.colorText);
const Description = styled.p.withConfig({
  displayName: "Description",
  componentId: "sc-13lgb7y-3"
})(["", " margin:0;color:", ";"], textStyles.paragraphM, token.colorTextMuted);
const Actions = styled.p.withConfig({
  displayName: "Actions",
  componentId: "sc-13lgb7y-4"
})(["display:flex;gap:", ";justify-content:center;margin:", " 0 0 !important;"], token.spacing4, token.spacing6);
export {
  EmptyState
};
//# sourceMappingURL=EmptyState.js.map
